import { PropsWithChildren } from 'react'

type SubtitleProps = {}

export const Subtitle = ({ children }: PropsWithChildren<SubtitleProps>) => {
  return <div className="text-sm text-gray-500">{children}</div>
}
